module.exports = __webpack_public_path__ + "public/files/img/schoolbus.33f91967.gif";